module.exports = __webpack_public_path__ + "img/big-ship-wreck-grass.8341d77f.png";